module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('no-auth-layout', {
    staticClass: "register-page"
  }, [_c('h2', {
    staticClass: "card-title center-align"
  }, [_vm._v("Rejestracja")]), _vm._v(" "), _c('p', {
    staticClass: "card-subtitle center-align"
  }, [_vm._v("Zarejestruj się i zarabiaj na polecaniu Punkta")]), _vm._v(" "), _c('div', {
    staticClass: "social-auth-container"
  }, [_c('div', {
    staticClass: "line-through-header center-align"
  }, [_c('span', [_vm._v("Zarejestruj się za pomocą:")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s12 m6 offset-m3"
  }, [_c('button', {
    staticClass: "btn waves-effect waves-light red lighten-1",
    attrs: {
      "id": "google"
    },
    on: {
      "click": function($event) {
        return _vm.authorize('google_oauth2')
      }
    }
  }, [_c('i', {
    staticClass: "mfind-icon mfind-icon-google left"
  }), _vm._v(" "), _c('span', [_vm._v("Google")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "email-auth-container"
  }, [_c('div', {
    staticClass: "line-through-header center-align"
  }, [_c('span', [_vm._v("lub przy użyciu "), _c('br'), _vm._v("adresu email:")])]), _vm._v(" "), _c('form', {
    attrs: {
      "method": "POST"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitRegister()
      }
    }
  }, [(_vm.data.errors) ? _c('div', {
    staticClass: "center-align validation-errors"
  }, [(_vm.data.errors['message']) ? _c('span', {
    staticClass: "red-text"
  }, [_vm._v("\n          " + _vm._s(_vm.data.errors['message'].join(', ')) + "\n        ")]) : _c('span', {
    staticClass: "red-text"
  }, [_vm._v("\n          Rejestracja nie była możliwa, uzupełnij lub popraw zaznaczone pola\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('input-field', {
    staticClass: "col s12 m6",
    attrs: {
      "type": "text",
      "name": "first_name",
      "label": "Imię",
      "required": "true",
      "errors": _vm.data.errors['first_name']
    },
    on: {
      "updateError": function (val) { return _vm.data.errors['first_name'] = val; }
    },
    model: {
      value: (_vm.data.first_name),
      callback: function($$v) {
        _vm.$set(_vm.data, "first_name", $$v)
      },
      expression: "data.first_name"
    }
  }), _vm._v(" "), _c('input-field', {
    staticClass: "col s12 m6",
    attrs: {
      "type": "text",
      "name": "last_name",
      "label": "Nazwisko",
      "required": "true",
      "errors": _vm.data.errors['last_name']
    },
    on: {
      "updateError": function (val) { return _vm.data.errors['last_name'] = val; }
    },
    model: {
      value: (_vm.data.last_name),
      callback: function($$v) {
        _vm.$set(_vm.data, "last_name", $$v)
      },
      expression: "data.last_name"
    }
  })], 1), _vm._v(" "), _c('input-field', {
    attrs: {
      "type": "email",
      "name": "email",
      "label": "Adres e-mail",
      "required": "true",
      "errors": _vm.data.errors['email']
    },
    on: {
      "updateError": function (val) { return _vm.data.errors['email'] = val; }
    },
    model: {
      value: (_vm.data.email),
      callback: function($$v) {
        _vm.$set(_vm.data, "email", $$v)
      },
      expression: "data.email"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('input-field', {
    staticClass: "col s12 m6",
    attrs: {
      "type": "password",
      "name": "password",
      "label": "Hasło",
      "required": "true",
      "errors": _vm.data.errors['password']
    },
    on: {
      "updateError": function (val) { return _vm.data.errors['password'] = val; }
    },
    model: {
      value: (_vm.data.password),
      callback: function($$v) {
        _vm.$set(_vm.data, "password", $$v)
      },
      expression: "data.password"
    }
  }), _vm._v(" "), _c('input-field', {
    staticClass: "col s12 m6",
    attrs: {
      "type": "password",
      "name": "password_confirmation",
      "label": "Powtórz hasło",
      "required": "true",
      "errors": _vm.data.errors['password_confirmation']
    },
    on: {
      "updateError": function (val) { return _vm.data.errors['password_confirmation'] = val; }
    },
    model: {
      value: (_vm.data.password_confirmation),
      callback: function($$v) {
        _vm.$set(_vm.data, "password_confirmation", $$v)
      },
      expression: "data.password_confirmation"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row col"
  }, [_vm._v("\n        Administratorem podanych danych osobowych będzie punkta sp. z o.o. Dane będą przetwarzane w celu zawarcia i\n        wykonania umowy uczestnictwa w programie partnerskim punkta.pl na zasadach określonych w\n        "), _c('a', {
    staticClass: "rules",
    attrs: {
      "href": "https://dokumenty.punkta.pl/Regulamin-Programu-Partnerskiego-Punkta.pdf",
      "target": "_blank"
    }
  }, [_vm._v("Regulaminie")]), _vm._v(".\n        Czytaj więcej w\n        "), _c('a', {
    staticClass: "rules",
    attrs: {
      "href": "https://punkta.pl/regulaminy/#polityka-prywatnosci-autoopen",
      "target": "_blank"
    }
  }, [_vm._v("Polityce prywatności")]), _vm._v(".\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn-large z-depth-0",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Zarejestruj się")])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._v("\n    Masz już konto? "), _c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("Zaloguj się")])], 1), _vm._v(" "), _c('Loader', {
    attrs: {
      "loading": _vm.data.loading
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a4931414","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/register.vue
// module id = 398
// module chunks = 0